<template>
    <div class="container mt-4">
        <div class="mb-3">
            <h1>New scan</h1>
        </div>

        <form @submit.prevent="scan" style="width:50%;">
            <div class="mb-3">
                <strong><label for="addDomains" class="form-label text-primary">Add domains</label></strong>
                <input v-model="domains" type="text" id="addDomains" class="form-control" aria-describedby="domainsHelpBlock" required
                :class="['form-control', isSubmitted ? (domainError ? 'is-invalid' : 'is-valid') : '']">
                <div id="domainsHelpBlock" class="form-text">
                    Please add domains separated by commas.
                </div>
                <!-- Conditionally display the error message for domains -->
                <p v-if="domainError" class="form-text text-danger">{{ domainError }}</p>
            </div>

            <div class="mb-3">
                <div id="scans">
                    <strong><label class="form-label text-primary" for="scans">Select scans</label></strong>

                    <div class="form-check form-switch">
                        <input v-model="email_security_scan" class="form-check-input" type="checkbox" role="switch" id="emailSecurityScanSwitch" aria-checked="true">
                        <label class="form-check-label" for="emailSecurityScanSwitch">Email security</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="dnssec_scan" class="form-check-input" type="checkbox" role="switch" id="dnssecScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="dnssecScanSwitch">DNSSEC</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="security_headers_scan" class="form-check-input" type="checkbox" role="switch" id="securityHeadersScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="securityHeadersScanSwitch">Security headers</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="https_scan" class="form-check-input" type="checkbox" role="switch" id="httpsScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="httpsScanSwitch">HTTPS</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="reputation_scan" class="form-check-input" type="checkbox" role="switch" id="reputationScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="reputationScanSwitch">Reputation</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="secrets_scan" class="form-check-input" type="checkbox" role="switch" id="secretsScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="secretsScanSwitch">Secrets</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="vulnerability_scan" class="form-check-input" type="checkbox" role="switch" id="vulnerabilityScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="vulnerabilityScanSwitch">Vulnerabilities</label>
                    </div>

                    <div class="form-check form-switch">
                        <input v-model="email_breach_scan" class="form-check-input" type="checkbox" role="switch" id="emailBreachScanSwitch" aria-checked="true" checked>
                        <label class="form-check-label" for="emailBreachScanSwitch">Breached emails</label>
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <button type="submit" class="btn btn-primary rounded-pill px-4">Scan</button>
                <router-link to="/scans/" class="btn btn-secondary rounded-pill ms-2 px-4">Back</router-link>
            </div>
        </form>
    </div>
</template>

<script>
import { ref } from 'vue';
import api from '../../../api/index.js'

export default {
    name: 'AddScanView',
    setup() {
        const domains = ref('');
        const email_security_scan = ref(true)
        const dnssec_scan = ref(true)
        const security_headers_scan = ref(true)
        const https_scan = ref(true)
        const reputation_scan = ref(true)
        const secrets_scan = ref(true)
        const vulnerability_scan = ref(true)
        const email_breach_scan = ref(true)
        const domainError = ref('');
        const isSubmitted = ref(false);  // Track if form is submitted

        const scan = async () => {
            const domains_list = domains.value.split(',').map(item => item.trim());
            domainError.value = '';  // Clear the error message before a new scan attempt
            isSubmitted.value = true;

            try {
                const response = await api.post(
                    '/scan/',
                    {
                        domains: domains_list,
                        "email_security_scan": email_security_scan.value,
                        "dnssec_scan": dnssec_scan.value,
                        "security_headers_scan": security_headers_scan.value,
                        "https_scan": https_scan.value,
                        "reputation_scan": reputation_scan.value,
                        "secrets_scan": secrets_scan.value,
                        "vulnerability_scan": vulnerability_scan.value,
                        "email_breach_scan": email_breach_scan.value
                    }
                );

                domainError.value = '';  // Clear errors on successful submission
                isSubmitted.value = false;  // Reset form submission status

                const scan_id = response.data.scan_id
                window.location.href = `/scans/${scan_id}`
            } catch (error) {
                console.error('Error adding new scans:', error);

                // Extract domains error from the response if available
                if (error.response && error.response.data.errors && error.response.data.errors.domains) {
                    const domainErrors = error.response.data.errors.domains;
                    const firstErrorKey = Object.keys(domainErrors)[0];  // Get the first key
                    domainError.value = `${firstErrorKey}: ${domainErrors[firstErrorKey].join(', ')}`;
                } else {
                    domainError.value = 'An unexpected error occurred.';
                }
            }
        }

        return {
            domains,
            email_security_scan,
            dnssec_scan,
            security_headers_scan,
            https_scan,
            reputation_scan,
            secrets_scan,
            vulnerability_scan,
            email_breach_scan,
            scan,
            domainError,
            isSubmitted
        };
    }
}
</script>
